import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import UptimeTimeline from '~/javascript/components/admin/uptime/UptimeTimeline.vue'

/**
 * Uptime Timeline Controller
 *
 * Mounts the Vue UptimeTimeline component for response time chart.
 */
export default class extends Controller {
  static targets = ['container', 'rangeSelect']

  static values = {
    websiteId: String,
    hours: { type: Number, default: 24 }
  }

  connect() {
    console.log('[UptimeTimeline] Connected for website:', this.websiteIdValue)
    if (this.hasContainerTarget) {
      this.mountVueComponent()
    }
  }

  disconnect() {
    if (this.vueApp) {
      this.vueApp.unmount()
      this.vueApp = null
    }
  }

  mountVueComponent() {
    this.vueApp = createApp(UptimeTimeline, {
      websiteId: this.websiteIdValue,
      hours: this.hoursValue,
      apiUrl: `/admin/websites/${this.websiteIdValue}/uptime/timeline_data`
    })

    this.vueApp.mount(this.containerTarget)
  }

  changeRange(event) {
    const hours = parseInt(event.target.value, 10)
    this.hoursValue = hours

    // Remount with new hours value
    if (this.vueApp) {
      this.vueApp.unmount()
    }
    this.mountVueComponent()
  }
}
